export default function () {
    document.addEventListener('DOMContentLoaded', function () {
        const categoriesList = document.querySelector(".blog-listing__categories-list");
        const categoriesTitle = document.querySelector(".blog-listing__categories-title");
        const categoriesArrow = document.querySelector(".categories-arrow");
        const categoriesBox = document.querySelector(".blog-listing__categories-box");
        const copyLink = document.querySelector(".blog-single-post__content-share .copy-link");
        const linkCopied = document.querySelector<HTMLInputElement>('.link-copeid-text');

        categoriesTitle?.addEventListener('click', () => {
            categoriesList?.classList.toggle("hidden-list")
            categoriesArrow?.classList.toggle("arrow-rotated")
        })

        window.addEventListener("wheel", e => {
            const scrollDirection = e.deltaY < 0 ? 1 : 0
            scrollDirection ? (categoriesBox?.classList.add('scrolling-top')) : (categoriesBox?.classList.remove('scrolling-top'));
        })

        copyLink?.addEventListener("click", function() {
            const url = window.location.href;
            const textarea = document.createElement("textarea");
            textarea.value = url;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            
            alert(linkCopied?.value);
            
        });
    })
}